module.exports = __webpack_public_path__ + "img/img-16.e9022c6f.png";